import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventType } from '../../constants';

export class GaTrackingFlixMediaContentViewedEvent implements GATrackingEvent {

  constructor(
    private type: string,
    private event: string,
    private category: string,
    private action?: string,
    private label?: string,
    private gtmCustom?: any) {
  }

  getEventType(): GATrackingEventType {
    return GATrackingEventType.FlixMediaContentView;
  }

  getPayload(): any {
    return {
      type: this.type,
      event: this.event,
      category: this.category,
      action: this.action,
      label: this.label,
      gtmCustom: this.gtmCustom
    };
  }
}
